import { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export const FieldTitle: FunctionComponent<any> = props => {
  return <p className={classNames(styles.fieldTitle, props.className)}>{props.children}</p>;
};
